/* WARNING: This file is auto-generated . Do not edit manually. */

import { PriceDedicatedCloud2016v6Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v6Sbg1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2014v1Bhs1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2014v1Bhs1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2018v6Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v6Eri1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v6Eri1cInfrastructureFilerHourlyEnum';
import { PriceVpsCloudOptionEnum } from '../models/PriceVpsCloudOptionEnum';
import { PriceDedicatedCloud2016v4Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v2Bhs1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Bhs1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v2Lim1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v2Lim1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v1Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Bhs1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v3Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v3Rbx2bInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v2Bhs1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v2Bhs1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2016v5Bhs1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Bhs1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2018v2Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v2Bhs1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v6Sbg1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v6Sbg1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedServerFirewallEnum } from '../models/PriceDedicatedServerFirewallEnum';
import { PriceDedicatedCloud2016v1Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2bInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2014v2Bhs1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Bhs1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v7Sbg1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Sbg1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2018v5Lim1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v5Lim1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v3Rbx2bEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2bEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2016v3Bhs1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v3Bhs1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v4Sbg1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v4Sbg1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2018v5Waw1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Waw1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v7Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2014v1Bhs1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v1Bhs1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2018v6Lim1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v6Lim1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v4Bhs1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v4Bhs1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v1Rbx2bEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2bEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v1Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v1Rbx2bInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v3Eri1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Eri1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v7Waw1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v7Waw1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v4Lim1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v4Lim1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v4Sbg1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Sbg1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v6Waw1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v6Waw1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v7Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Sbg1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v6Rbx2aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2014v2Rbx2bEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2bEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v4Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v2Sbg1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Sbg1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2018v4Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v4Sbg1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v5Sbg1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v5Sbg1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2016v3Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v3Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Bhs1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2014v1Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v2Eri1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v2Eri1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2014v1Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2013v1Bhs1aHostHourlyEnum } from '../models/PriceDedicatedCloud2013v1Bhs1aHostHourlyEnum';
import { PriceDedicatedCloud2018v5Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v5Sbg1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v7Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceXdslInstallationEnum } from '../models/PriceXdslInstallationEnum';
import { PriceDedicatedCloud2018v1Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v1Rbx2bInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v4Rbx2bEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2bEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2018v2Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v2Sbg1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v4Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v4Sbg1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v2Lim1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Lim1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v2Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v2Bhs1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2014v2Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v6Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceVps2017v3CloudModelEnum } from '../models/PriceVps2017v3CloudModelEnum';
import { PriceDedicatedCloud2018v3Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Sbg1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v5Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v1Rbx2aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2aEnterpriseFilerMonthlyEnum';
import { PriceVpsClassicModelEnum } from '../models/PriceVpsClassicModelEnum';
import { PriceDedicatedCloud2016v3Rbx2bEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2bEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v6Bhs1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Bhs1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v5Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v7Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v4Rbx2aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2018v2Rbx2dInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Rbx2dInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2014v2Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v6Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Rbx2bInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v7Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v7Bhs1aInfrastructureHostHourlyEnum';
import { PriceXdslOptionsIpv4Enum } from '../models/PriceXdslOptionsIpv4Enum';
import { PriceDedicatedCloud2018v4Lim1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Lim1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v5Lim1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Lim1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v3Eri1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Eri1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v3Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceVps2014v1CloudModelEnum } from '../models/PriceVps2014v1CloudModelEnum';
import { PriceDedicatedCloud2018v3Lim1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Lim1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v2Waw1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Waw1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v5Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v7Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v7Rbx2bEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2bEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2018v2Rbx2dInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v2Rbx2dInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2014v2Rbx2aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v5Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Rbx2bInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2014v1Sbg1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2014v1Sbg1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2018v6Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2013v1Sbg1aFilerMonthlyEnum } from '../models/PriceDedicatedCloud2013v1Sbg1aFilerMonthlyEnum';
import { PriceDedicatedCloud2016v2Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v3Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v3Bhs1aInfrastructureHostHourlyEnum';
import { PriceVps2017v2SsdOptionEnum } from '../models/PriceVps2017v2SsdOptionEnum';
import { PriceDedicatedCloud2016v4Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v2Rbx2dInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v2Rbx2dInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v7Rbx2bEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2bEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2018v1Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceVps2017v1SsdOptionEnum } from '../models/PriceVps2017v1SsdOptionEnum';
import { PriceDedicatedCloud2018v1Lim1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v1Lim1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v1Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2bInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v4Sbg1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v4Sbg1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v3Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v4Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Bhs1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v3Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceVps2017v1SsdModelEnum } from '../models/PriceVps2017v1SsdModelEnum';
import { PriceDedicatedCloud2016v7Rbx2aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2014v1Bhs1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Bhs1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v5Eri1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Eri1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v1Bhs1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v1Bhs1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2018v2Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v3Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2bInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v2Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Bhs1aInfrastructureHostMonthlyEnum';
import { PriceVpsLowlatModelEnum } from '../models/PriceVpsLowlatModelEnum';
import { PriceDedicatedCloud2018v5Waw1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Waw1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v6Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Rbx2aInfrastructureHostMonthlyEnum';
import { PriceVps2018v1CloudOptionEnum } from '../models/PriceVps2018v1CloudOptionEnum';
import { PriceDedicatedCloud2018v5Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v5Bhs1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v6Sbg1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Sbg1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2018v3Lim1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v3Lim1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v4Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v4Sbg1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v7Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v3Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v3Bhs1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2014v2Rbx2bEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2bEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2013v1Sbg1aHostHourlyEnum } from '../models/PriceDedicatedCloud2013v1Sbg1aHostHourlyEnum';
import { PriceDedicatedCloud2014v1Rbx2bEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2bEnterpriseHostMonthlyEnum';
import { PriceVps2015v1CloudModelEnum } from '../models/PriceVps2015v1CloudModelEnum';
import { PriceDedicatedCloud2018v1Rbx2dInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Rbx2dInfrastructureFilerMonthlyEnum';
import { PriceVps2013v1ClassicModelEnum } from '../models/PriceVps2013v1ClassicModelEnum';
import { PriceDedicatedCloud2014v1Sbg1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Sbg1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2014v1Sbg1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v1Sbg1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v5Bhs1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v5Bhs1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2014v2Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v2Sbg1aInfrastructureFilerHourlyEnum';
import { PriceVps2017v3CloudOptionEnum } from '../models/PriceVps2017v3CloudOptionEnum';
import { PriceDedicatedCloud2016v7Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v7Bhs1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v7Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v4Rbx2dInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Rbx2dInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v4Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v4Bhs1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v1Rbx2bEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2bEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2016v3Bhs1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Bhs1aEnterpriseFilerMonthlyEnum';
import { PriceXdslOptionsInstallationEnum } from '../models/PriceXdslOptionsInstallationEnum';
import { PriceDedicatedCloud2016v3Bhs1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v3Bhs1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2016v5Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v5Bhs1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v2Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2bInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2013v1Sbg1aHostMonthlyEnum } from '../models/PriceDedicatedCloud2013v1Sbg1aHostMonthlyEnum';
import { PriceDedicatedCloud2016v4Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v6Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v6Rbx2bEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2bEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2014v1Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v7Eri1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Eri1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2014v2Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2bInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v1Waw1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v1Waw1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v2Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v2Bhs1aInfrastructureFilerHourlyEnum';
import { PriceVps2013v1CloudModelEnum } from '../models/PriceVps2013v1CloudModelEnum';
import { PriceDedicatedCloud2014v2Sbg1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2014v2Sbg1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2018v4Rbx2dInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Rbx2dInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v4Waw1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Waw1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v3Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v3Bhs1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v6Lim1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v6Lim1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v1Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v1Rbx2dInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v1Rbx2dInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v1Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v1Sbg1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v7Bhs1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v7Bhs1aEnterpriseFilerHourlyEnum';
import { OrderPrice } from '../models/OrderPrice';
import { PriceDedicatedCloud2018v6Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v6Bhs1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v1Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v1Sbg1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v1Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2bInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v5Bhs1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Bhs1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v2Eri1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Eri1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v7Rbx2dInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v7Rbx2dInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v3Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2014v2Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2bInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v2Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v1Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v1Bhs1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v1Sbg1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v1Sbg1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2016v7Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2aInfrastructureHostMonthlyEnum';
import { PriceVps2017v3CloudramOptionEnum } from '../models/PriceVps2017v3CloudramOptionEnum';
import { PriceDedicatedCloud2016v6Bhs1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Bhs1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v7Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v7Bhs1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v4Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2bInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v1Bhs1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Bhs1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v6Rbx2bEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2bEnterpriseFilerMonthlyEnum';
import { PriceVps2018v1CloudramModelEnum } from '../models/PriceVps2018v1CloudramModelEnum';
import { PriceDedicatedCloud2014v1Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2bInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v6Sbg1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v6Sbg1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2016v7Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2bInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v2Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v2Sbg1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v2Lim1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v2Lim1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v6Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v6Rbx2aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2014v2Rbx2bEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2bEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2018v2Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v2Sbg1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v5Rbx2aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2016v6Rbx2aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v3Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2014v1Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v7Lim1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v7Lim1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v1Lim1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v1Lim1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v6Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v7Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v7Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v7Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Rbx2bInfrastructureHostMonthlyEnum';
import { PriceVps2018v1SsdModelEnum } from '../models/PriceVps2018v1SsdModelEnum';
import { PriceDedicatedCloud2018v7Waw1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Waw1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2014v1Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v2Waw1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Waw1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2014v2Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Sbg1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v2Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v2Rbx2bInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2014v1Rbx2aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v1Bhs1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Bhs1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v5Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Bhs1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v3Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Sbg1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2014v1Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v1Bhs1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v6Eri1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Eri1cInfrastructureHostMonthlyEnum';
import { PriceVps2015v1CloudOptionEnum } from '../models/PriceVps2015v1CloudOptionEnum';
import { PriceDedicatedCloud2013v1Rbx2aFilerHourlyEnum } from '../models/PriceDedicatedCloud2013v1Rbx2aFilerHourlyEnum';
import { PriceDedicatedCloud2014v1Rbx2aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v1Rbx2bEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2bEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2013v1Bhs1aFilerMonthlyEnum } from '../models/PriceDedicatedCloud2013v1Bhs1aFilerMonthlyEnum';
import { PriceDedicatedCloud2016v5Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Bhs1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v6Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2bInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v4Rbx2bEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2bEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v4Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Rbx2bInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v4Rbx2bEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2bEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2018v1Lim1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Lim1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2014v1Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v5Rbx2dInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v5Rbx2dInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2014v1Sbg1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Sbg1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v4Rbx2aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v5Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v5Sbg1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2014v1Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Sbg1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2014v2Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Bhs1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v4Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v4Rbx2dInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v4Rbx2dInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v4Rbx2bEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2bEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2018v3Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v3Sbg1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v1Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v2Lim1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Lim1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v6Rbx2bEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2bEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v5Bhs1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v5Bhs1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2016v4Bhs1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Bhs1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v6Rbx2bEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2bEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2018v6Waw1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Waw1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v1Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v1Rbx2aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v1Lim1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Lim1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v4Rbx2aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v7Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2aInfrastructureFilerHourlyEnum';
import { PriceVps2015v1SsdOptionEnum } from '../models/PriceVps2015v1SsdOptionEnum';
import { PriceDedicatedCloud2018v5Rbx2dInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Rbx2dInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v5Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2bInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v5Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2bInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v5Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v5Sbg1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v4Rbx2aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v6Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Bhs1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v5Sbg1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Sbg1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v4Bhs1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v4Bhs1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2018v6Rbx2dInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Rbx2dInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v7Bhs1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Bhs1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v7Rbx2aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v4Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2014v2Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v4Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v4Bhs1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v6Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v6Bhs1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v7Bhs1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Bhs1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v2Eri1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v2Eri1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2014v2Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2014v2Bhs1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v4Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Sbg1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2013v1Bhs1aHostMonthlyEnum } from '../models/PriceDedicatedCloud2013v1Bhs1aHostMonthlyEnum';
import { PriceDedicatedCloud2018v2Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceDedicatedServerBackupStorageEnum } from '../models/PriceDedicatedServerBackupStorageEnum';
import { PriceDedicatedCloud2018v3Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v3Bhs1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v3Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2014v2Rbx2bEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2bEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v5Rbx2aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v1Rbx2aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2016v3Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2bInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2014v1Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2014v1Bhs1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v2Sbg1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v2Sbg1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v5Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2014v1Rbx2bEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2bEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v2Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Bhs1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v4Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v4Rbx2bInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v2Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v2Rbx2aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2014v2Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v2Rbx2dInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Rbx2dInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v5Eri1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v5Eri1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v6Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v6Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Sbg1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v7Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Bhs1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v7Rbx2dInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Rbx2dInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v3Rbx2dInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Rbx2dInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2014v2Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2aInfrastructureHostMonthlyEnum';
import { PriceVps2018v1CloudramOptionEnum } from '../models/PriceVps2018v1CloudramOptionEnum';
import { PriceDedicatedCloud2016v6Bhs1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v6Bhs1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2018v3Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v3Rbx2bInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2014v1Rbx2aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2016v2Sbg1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Sbg1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v3Rbx2dInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v3Rbx2dInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v5Rbx2aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v7Sbg1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Sbg1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v1Eri1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Eri1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2014v2Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v5Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v5Lim1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Lim1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v1Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v6Bhs1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v6Bhs1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2018v6Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v6Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2014v2Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2bInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v7Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v7Rbx2aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v4Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Rbx2aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v7Sbg1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v7Sbg1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2018v6Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v6Rbx2bInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v2Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v7Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Sbg1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v7Lim1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Lim1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v6Sbg1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Sbg1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2016v7Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v7Bhs1aInfrastructureFilerHourlyEnum';
import { PriceVps2018v1CloudModelEnum } from '../models/PriceVps2018v1CloudModelEnum';
import { PriceDedicatedCloud2018v3Rbx2dInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v3Rbx2dInfrastructureFilerHourlyEnum';
import { PriceVps2013v1CloudOptionEnum } from '../models/PriceVps2013v1CloudOptionEnum';
import { PriceDedicatedCloud2018v7Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v7Rbx2bInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v1Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v1Bhs1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v4Waw1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Waw1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v5Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v5Bhs1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v1Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v6Lim1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Lim1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v6Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v6Sbg1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2014v1Rbx2bEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2bEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2018v7Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v4Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2bInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v7Waw1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v7Waw1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v5Waw1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v5Waw1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v2Bhs1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Bhs1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v5Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2bInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v3Rbx2aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2016v6Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2014v2Rbx2aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2018v3Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Rbx2bInfrastructureHostMonthlyEnum';
import { PriceVps2017v3SsdOptionEnum } from '../models/PriceVps2017v3SsdOptionEnum';
import { PriceDedicatedCloud2018v7Eri1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v7Eri1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v1Waw1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v1Waw1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v2Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Sbg1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v3Waw1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v3Waw1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v4Eri1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v4Eri1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v7Eri1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Eri1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v2Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Sbg1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2014v2Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2014v1Rbx2aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2aEnterpriseHostHourlyEnum';
import { PriceVps2017v2SsdModelEnum } from '../models/PriceVps2017v2SsdModelEnum';
import { PriceDedicatedCloud2018v6Waw1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Waw1cInfrastructureHostMonthlyEnum';
import { PriceVps2018v1SsdOptionEnum } from '../models/PriceVps2018v1SsdOptionEnum';
import { PriceDedicatedCloud2018v4Rbx2dInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v4Rbx2dInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2014v2Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2014v2Sbg1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2013v1Bhs1aFilerHourlyEnum } from '../models/PriceDedicatedCloud2013v1Bhs1aFilerHourlyEnum';
import { PriceDedicatedCloud2018v6Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v6Bhs1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v3Rbx2aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v3Sbg1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Sbg1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2018v1Waw1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Waw1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v3Rbx2aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2aEnterpriseHostMonthlyEnum';
import { PriceDomainZoneOptionEnum } from '../models/PriceDomainZoneOptionEnum';
import { PriceDedicatedCloud2016v5Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v5Sbg1aInfrastructureHostHourlyEnum';
import { PriceOverTheBoxOfferEnum } from '../models/PriceOverTheBoxOfferEnum';
import { PriceDedicatedCloud2018v3Lim1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v3Lim1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v5Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v5Rbx2aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v5Rbx2dInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v5Rbx2dInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v1Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v7Sbg1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v7Sbg1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2013v1Rbx2aHostMonthlyEnum } from '../models/PriceDedicatedCloud2013v1Rbx2aHostMonthlyEnum';
import { PriceDedicatedCloud2018v7Rbx2dInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Rbx2dInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v2Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v2Sbg1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v6Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v6Sbg1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v2Sbg1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v2Sbg1aEnterpriseHostHourlyEnum';
import { PriceVps2015v1CloudramOptionEnum } from '../models/PriceVps2015v1CloudramOptionEnum';
import { PriceDedicatedCloud2016v1Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v1Bhs1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2014v1Bhs1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Bhs1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2018v4Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v4Rbx2bInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v7Lim1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v7Lim1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2014v1Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2bInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v4Bhs1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Bhs1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2016v7Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v7Sbg1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2014v2Bhs1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Bhs1aEnterpriseHostMonthlyEnum';
import { PriceHostingWebCdnEnum } from '../models/PriceHostingWebCdnEnum';
import { PriceDedicatedCloud2016v1Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v5Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Sbg1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v6Rbx2dInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Rbx2dInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v3Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v5Eri1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Eri1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v3Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v3Sbg1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v6Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2bInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v3Waw1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Waw1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v5Rbx2bEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2bEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v6Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v2Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v2Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v2Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v4Eri1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Eri1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v1Bhs1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v1Bhs1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2018v1Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Rbx2bInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v7Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v7Sbg1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v1Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v1Sbg1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v6Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v6Sbg1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v4Waw1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v4Waw1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v4Sbg1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Sbg1aEnterpriseFilerMonthlyEnum';
import { PriceVps2017v3SsdModelEnum } from '../models/PriceVps2017v3SsdModelEnum';
import { PriceXdslAddressMoveFeeEnum } from '../models/PriceXdslAddressMoveFeeEnum';
import { PriceDedicatedCloud2018v6Waw1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v6Waw1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2014v1Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v6Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v3Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Rbx2aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v2Waw1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v2Waw1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v2Eri1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Eri1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v5Rbx2aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2016v1Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Bhs1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v1Eri1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v1Eri1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v5Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2013v1Rbx2aFilerMonthlyEnum } from '../models/PriceDedicatedCloud2013v1Rbx2aFilerMonthlyEnum';
import { PriceVps2014v1CloudOptionEnum } from '../models/PriceVps2014v1CloudOptionEnum';
import { PriceDedicatedCloud2018v6Eri1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Eri1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v1Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Rbx2aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v2Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2bInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v1Rbx2dInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v1Rbx2dInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2014v2Sbg1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v2Sbg1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2018v5Waw1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v5Waw1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v5Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v1Rbx2dInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Rbx2dInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v6Rbx2aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2aEnterpriseHostHourlyEnum';
import { PriceVpsCloudModelEnum } from '../models/PriceVpsCloudModelEnum';
import { PriceHostingPrivateDatabaseEnum } from '../models/PriceHostingPrivateDatabaseEnum';
import { PriceDedicatedCloud2016v5Rbx2bEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2bEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2014v2Sbg1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Sbg1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v1Sbg1aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Sbg1aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2018v1Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceDedicatedServerIpEnum } from '../models/PriceDedicatedServerIpEnum';
import { PriceDedicatedCloud2018v7Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v7Rbx2bInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v2Rbx2aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v3Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v5Rbx2dInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Rbx2dInfrastructureHostMonthlyEnum';
import { PriceVps2017v2CloudOptionEnum } from '../models/PriceVps2017v2CloudOptionEnum';
import { PriceDedicatedCloud2016v6Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Bhs1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v7Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Bhs1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v4Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Sbg1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v2Rbx2bEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2bEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v1Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v1Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v2Rbx2aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v7Bhs1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v7Bhs1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2018v1Waw1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Waw1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v4Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v5Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v5Rbx2bInfrastructureHostHourlyEnum';
import { PriceVps2018v2SsdModelEnum } from '../models/PriceVps2018v2SsdModelEnum';
import { PriceDedicatedCloud2014v2Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v2Bhs1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2014v1Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v1Bhs1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v7Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2bInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v6Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2bInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v5Sbg1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v5Sbg1aEnterpriseFilerHourlyEnum';
import { PriceHostingWebExtraSqlPersoEnum } from '../models/PriceHostingWebExtraSqlPersoEnum';
import { PriceDedicatedCloud2018v6Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v6Rbx2bInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v1Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v1Bhs1aInfrastructureFilerHourlyEnum';
import { PriceVps2017v2CloudramModelEnum } from '../models/PriceVps2017v2CloudramModelEnum';
import { PriceDedicatedCloud2016v1Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Sbg1aInfrastructureHostMonthlyEnum';
import { PriceLicenseOfficeEnum } from '../models/PriceLicenseOfficeEnum';
import { PriceDedicatedCloud2018v3Waw1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Waw1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v2Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Rbx2bInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v5Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v7Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Rbx2aInfrastructureHostMonthlyEnum';
import { PriceVps2015v1CloudramModelEnum } from '../models/PriceVps2015v1CloudramModelEnum';
import { PriceDedicatedCloud2016v7Rbx2bEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2bEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2016v7Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v7Eri1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v7Eri1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v1Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v1Sbg1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v4Rbx2bInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2bInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v3Sbg1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v3Sbg1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2016v5Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v2Rbx2bEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2bEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v3Rbx2bEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2bEnterpriseHostHourlyEnum';
import { PriceVps2017v2CloudramOptionEnum } from '../models/PriceVps2017v2CloudramOptionEnum';
import { PriceDedicatedCloud2016v5Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Sbg1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2014v2Sbg1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Sbg1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v4Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Bhs1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v3Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v3Sbg1aInfrastructureHostHourlyEnum';
import { PriceVps2017v3CloudramModelEnum } from '../models/PriceVps2017v3CloudramModelEnum';
import { PriceDedicatedCloud2016v2Rbx2bEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2bEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2016v6Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v6Bhs1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v3Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2bInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v7Rbx2aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2018v5Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v5Rbx2bInfrastructureFilerHourlyEnum';
import { PriceXdslOptionsLineEnum } from '../models/PriceXdslOptionsLineEnum';
import { PriceDedicatedCloud2016v1Rbx2aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v1Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v3Eri1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v3Eri1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v3Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceVps2018v2SsdOptionEnum } from '../models/PriceVps2018v2SsdOptionEnum';
import { PriceDedicatedCloud2018v3Waw1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v3Waw1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v4Waw1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v4Waw1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v4Lim1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v4Lim1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v2Rbx2aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2018v2Waw1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v2Waw1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2014v2Bhs1aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2014v2Bhs1aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2016v1Sbg1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v1Sbg1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2018v7Rbx2dInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v7Rbx2dInfrastructureFilerHourlyEnum';
import { PriceDedicatedNashaModelEnum } from '../models/PriceDedicatedNashaModelEnum';
import { PriceDedicatedCloud2016v5Sbg1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Sbg1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2016v1Rbx2bEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2bEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v7Rbx2bEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2bEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2014v1Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2014v1Sbg1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v4Lim1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Lim1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v2Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v2Bhs1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v2Bhs1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2018v2Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v2Rbx2bInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v5Rbx2bEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2bEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2016v2Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v2Bhs1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v1Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Sbg1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2013v1Sbg1aFilerHourlyEnum } from '../models/PriceDedicatedCloud2013v1Sbg1aFilerHourlyEnum';
import { PriceXdslOffersEnum } from '../models/PriceXdslOffersEnum';
import { PriceDedicatedCloud2018v3Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v3Sbg1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v3Rbx2dInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Rbx2dInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v5Rbx2bEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v5Rbx2bEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2014v1Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v1Sbg1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v1Rbx2aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2016v1Sbg1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v1Sbg1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2018v7Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v7Sbg1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v4Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v4Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v3Sbg1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v3Sbg1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v3Rbx2bEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2bEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2018v4Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v4Rbx2aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v4Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v5Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Rbx2aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v2Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v3Rbx2aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v3Rbx2aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v3Rbx2aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Rbx2aEnterpriseFilerMonthlyEnum';
import { PriceDedicatedCloud2016v4Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v2Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v3Eri1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v3Eri1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v2Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2bInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v4Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v4Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedServerAntiDDoSProEnum } from '../models/PriceDedicatedServerAntiDDoSProEnum';
import { PriceDedicatedCloud2016v7Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2014v2Rbx2aEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2aEnterpriseFilerMonthlyEnum';
import { PriceSaasCsp2LicenseEnum } from '../models/PriceSaasCsp2LicenseEnum';
import { PriceDedicatedCloud2014v1Rbx2bInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2bInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v7Sbg1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v7Sbg1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v4Eri1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v4Eri1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v3Bhs1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Bhs1aEnterpriseHostMonthlyEnum';
import { PriceDedicatedCloud2016v4Bhs1aInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v4Bhs1aInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2016v6Rbx2aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2014v1Rbx2bEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2014v1Rbx2bEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2013v1Rbx2aHostHourlyEnum } from '../models/PriceDedicatedCloud2013v1Rbx2aHostHourlyEnum';
import { PriceDedicatedCloud2018v7Waw1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Waw1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v1Eri1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Eri1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2014v2Rbx2aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2014v2Rbx2aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2018v5Eri1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v5Eri1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v6Eri1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v6Eri1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v5Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v5Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2016v6Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v6Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v5Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v5Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v7Rbx2bInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2bInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v3Lim1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Lim1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v5Rbx2bInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v5Rbx2bInfrastructureFilerMonthlyEnum';
import { PriceVps2014v1ClassicModelEnum } from '../models/PriceVps2014v1ClassicModelEnum';
import { PriceDedicatedCloud2018v3Bhs1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Bhs1aInfrastructureHostMonthlyEnum';
import { PriceVps2017v2CloudModelEnum } from '../models/PriceVps2017v2CloudModelEnum';
import { PriceDedicatedCloud2016v2Rbx2aEnterpriseHostHourlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2aEnterpriseHostHourlyEnum';
import { PriceDedicatedCloud2014v2Bhs1aEnterpriseFilerHourlyEnum } from '../models/PriceDedicatedCloud2014v2Bhs1aEnterpriseFilerHourlyEnum';
import { PriceDedicatedCloud2016v5Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v5Bhs1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v1Rbx2aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v1Rbx2aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v1Eri1cInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v1Eri1cInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v3Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v3Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v2Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v6Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v2Bhs1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Bhs1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2018v6Sbg1aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Sbg1aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v5Lim1cInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v5Lim1cInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v7Lim1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v7Lim1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v2Rbx2bEnterpriseFilerMonthlyEnum } from '../models/PriceDedicatedCloud2016v2Rbx2bEnterpriseFilerMonthlyEnum';
import { PriceVps2015v1SsdModelEnum } from '../models/PriceVps2015v1SsdModelEnum';
import { PriceDedicatedCloud2016v7Rbx2aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v7Rbx2aEnterpriseHostMonthlyEnum';
import { PriceHostingWebSslEnum } from '../models/PriceHostingWebSslEnum';
import { PriceVps2013v1LowlatModelEnum } from '../models/PriceVps2013v1LowlatModelEnum';
import { PriceDedicatedCloud2018v6Rbx2dInfrastructureFilerHourlyEnum } from '../models/PriceDedicatedCloud2018v6Rbx2dInfrastructureFilerHourlyEnum';
import { PriceDedicatedCloud2018v2Rbx2aInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v2Rbx2aInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2016v4Sbg1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v4Sbg1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v3Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v3Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v6Lim1cInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v6Lim1cInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v1Rbx2aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2016v1Rbx2aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v4Eri1cInfrastructureHostMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Eri1cInfrastructureHostMonthlyEnum';
import { PriceDedicatedCloud2018v4Bhs1aInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v4Bhs1aInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v6Rbx2dInfrastructureHostHourlyEnum } from '../models/PriceDedicatedCloud2018v6Rbx2dInfrastructureHostHourlyEnum';
import { PriceDedicatedCloud2018v4Sbg1aInfrastructureFilerMonthlyEnum } from '../models/PriceDedicatedCloud2018v4Sbg1aInfrastructureFilerMonthlyEnum';
import { PriceDedicatedCloud2016v3Sbg1aEnterpriseHostMonthlyEnum } from '../models/PriceDedicatedCloud2016v3Sbg1aEnterpriseHostMonthlyEnum';
import OVHBase from '../ovh';

class PriceHandler {
  ovh: OVHBase;

  constructor(ovh: OVHBase) {
    this.ovh = ovh;
  }

  /** Get the price of Nas HA offers */
  getDedicatedNashaModelByModelName = (
    modelName: PriceDedicatedNashaModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/dedicated/nasha/model/${modelName}`);
  };

  /** Get price of anti-DDos Pro option */
  getDedicatedServerAntiDDoSProByCommercialRange = (
    commercialRange: PriceDedicatedServerAntiDDoSProEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/dedicated/server/antiDDoSPro/${commercialRange}`);
  };

  /** Get price of backup storage offer */
  getDedicatedServerBackupStorageByCapacity = (
    capacity: PriceDedicatedServerBackupStorageEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/dedicated/server/backupStorage/${capacity}`);
  };

  /** Get price of available firewall models */
  getDedicatedServerFirewallByFirewallModel = (
    firewallModel: PriceDedicatedServerFirewallEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/dedicated/server/firewall/${firewallModel}`);
  };

  /** Get price of IPs */
  getDedicatedServerIpByRoutedTo = (routedTo: PriceDedicatedServerIpEnum): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/dedicated/server/ip/${routedTo}`);
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2013v1Bhs1aFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2013v1Bhs1aFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2013v1/bhs1a/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2013v1Bhs1aFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2013v1Bhs1aFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2013v1/bhs1a/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2013v1Bhs1aHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2013v1Bhs1aHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/dedicatedCloud/2013v1/bhs1a/host/hourly/${hostProfile}`);
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2013v1Bhs1aHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2013v1Bhs1aHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2013v1/bhs1a/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2013v1Rbx2aFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2013v1Rbx2aFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2013v1/rbx2a/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2013v1Rbx2aFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2013v1Rbx2aFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2013v1/rbx2a/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2013v1Rbx2aHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2013v1Rbx2aHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/dedicatedCloud/2013v1/rbx2a/host/hourly/${hostProfile}`);
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2013v1Rbx2aHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2013v1Rbx2aHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2013v1/rbx2a/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2013v1Sbg1aFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2013v1Sbg1aFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2013v1/sbg1a/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2013v1Sbg1aFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2013v1Sbg1aFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2013v1/sbg1a/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2013v1Sbg1aHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2013v1Sbg1aHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/dedicatedCloud/2013v1/sbg1a/host/hourly/${hostProfile}`);
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2013v1Sbg1aHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2013v1Sbg1aHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2013v1/sbg1a/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v1Bhs1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Bhs1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/bhs1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v1Bhs1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Bhs1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/bhs1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v1Bhs1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Bhs1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/bhs1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v1Bhs1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Bhs1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/bhs1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v1Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v1Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v1Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v1Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v1Rbx2aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Rbx2aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v1Rbx2aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Rbx2aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v1Rbx2aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Rbx2aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v1Rbx2aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Rbx2aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v1Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v1Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v1Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v1Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v1Rbx2bEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Rbx2bEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2b/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v1Rbx2bEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Rbx2bEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2b/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v1Rbx2bEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Rbx2bEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2b/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v1Rbx2bEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Rbx2bEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2b/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v1Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v1Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v1Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v1Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v1Sbg1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Sbg1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/sbg1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v1Sbg1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Sbg1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/sbg1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v1Sbg1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Sbg1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/sbg1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v1Sbg1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Sbg1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/sbg1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v1Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v1Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v1Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v1Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v1Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v1Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v1/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v2Bhs1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Bhs1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/bhs1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v2Bhs1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Bhs1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/bhs1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v2Bhs1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Bhs1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/bhs1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v2Bhs1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Bhs1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/bhs1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v2Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v2Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v2Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v2Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v2Rbx2aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Rbx2aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v2Rbx2aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Rbx2aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v2Rbx2aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Rbx2aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v2Rbx2aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Rbx2aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v2Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v2Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v2Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v2Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v2Rbx2bEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Rbx2bEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2b/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v2Rbx2bEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Rbx2bEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2b/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v2Rbx2bEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Rbx2bEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2b/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v2Rbx2bEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Rbx2bEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2b/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v2Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v2Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v2Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v2Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v2Sbg1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Sbg1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/sbg1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v2Sbg1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Sbg1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/sbg1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v2Sbg1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Sbg1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/sbg1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v2Sbg1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Sbg1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/sbg1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2014v2Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2014v2Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2014v2Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2014v2Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2014v2Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2014v2Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2014v2/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v1Bhs1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Bhs1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/bhs1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v1Bhs1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Bhs1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/bhs1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v1Bhs1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Bhs1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/bhs1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v1Bhs1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Bhs1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/bhs1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v1Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v1Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v1Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v1Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v1Rbx2aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Rbx2aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v1Rbx2aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Rbx2aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v1Rbx2aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Rbx2aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v1Rbx2aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Rbx2aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v1Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v1Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v1Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v1Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v1Rbx2bEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Rbx2bEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2b/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v1Rbx2bEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Rbx2bEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2b/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v1Rbx2bEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Rbx2bEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2b/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v1Rbx2bEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Rbx2bEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2b/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v1Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v1Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v1Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v1Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v1Sbg1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Sbg1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/sbg1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v1Sbg1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Sbg1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/sbg1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v1Sbg1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Sbg1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/sbg1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v1Sbg1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Sbg1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/sbg1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v1Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v1Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v1Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v1Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v1Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v1Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v1/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v2Bhs1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Bhs1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/bhs1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v2Bhs1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Bhs1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/bhs1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v2Bhs1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Bhs1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/bhs1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v2Bhs1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Bhs1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/bhs1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v2Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v2Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v2Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v2Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v2Rbx2aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Rbx2aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v2Rbx2aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Rbx2aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v2Rbx2aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Rbx2aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v2Rbx2aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Rbx2aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v2Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v2Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v2Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v2Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v2Rbx2bEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Rbx2bEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2b/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v2Rbx2bEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Rbx2bEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2b/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v2Rbx2bEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Rbx2bEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2b/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v2Rbx2bEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Rbx2bEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2b/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v2Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v2Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v2Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v2Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v2Sbg1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Sbg1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/sbg1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v2Sbg1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Sbg1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/sbg1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v2Sbg1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Sbg1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/sbg1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v2Sbg1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Sbg1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/sbg1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v2Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v2Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v2Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v2Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v2Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v2Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v2/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v3Bhs1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Bhs1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/bhs1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v3Bhs1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Bhs1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/bhs1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v3Bhs1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Bhs1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/bhs1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v3Bhs1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Bhs1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/bhs1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v3Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v3Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v3Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v3Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v3Rbx2aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Rbx2aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v3Rbx2aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Rbx2aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v3Rbx2aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Rbx2aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v3Rbx2aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Rbx2aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v3Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v3Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v3Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v3Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v3Rbx2bEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Rbx2bEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2b/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v3Rbx2bEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Rbx2bEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2b/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v3Rbx2bEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Rbx2bEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2b/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v3Rbx2bEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Rbx2bEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2b/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v3Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v3Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v3Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v3Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v3Sbg1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Sbg1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/sbg1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v3Sbg1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Sbg1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/sbg1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v3Sbg1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Sbg1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/sbg1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v3Sbg1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Sbg1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/sbg1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v3Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v3Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v3Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v3Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v3Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v3Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v3/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v4Bhs1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Bhs1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/bhs1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v4Bhs1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Bhs1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/bhs1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v4Bhs1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Bhs1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/bhs1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v4Bhs1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Bhs1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/bhs1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v4Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v4Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v4Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v4Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v4Rbx2aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Rbx2aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v4Rbx2aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Rbx2aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v4Rbx2aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Rbx2aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v4Rbx2aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Rbx2aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v4Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v4Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v4Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v4Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v4Rbx2bEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Rbx2bEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2b/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v4Rbx2bEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Rbx2bEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2b/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v4Rbx2bEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Rbx2bEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2b/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v4Rbx2bEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Rbx2bEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2b/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v4Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v4Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v4Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v4Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v4Sbg1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Sbg1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/sbg1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v4Sbg1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Sbg1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/sbg1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v4Sbg1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Sbg1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/sbg1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v4Sbg1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Sbg1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/sbg1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v4Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v4Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v4Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v4Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v4Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v4Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v4/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v5Bhs1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Bhs1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/bhs1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v5Bhs1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Bhs1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/bhs1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v5Bhs1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Bhs1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/bhs1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v5Bhs1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Bhs1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/bhs1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v5Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v5Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v5Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v5Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v5Rbx2aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Rbx2aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v5Rbx2aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Rbx2aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v5Rbx2aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Rbx2aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v5Rbx2aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Rbx2aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v5Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v5Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v5Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v5Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v5Rbx2bEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Rbx2bEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2b/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v5Rbx2bEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Rbx2bEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2b/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v5Rbx2bEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Rbx2bEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2b/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v5Rbx2bEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Rbx2bEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2b/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v5Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v5Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v5Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v5Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v5Sbg1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Sbg1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/sbg1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v5Sbg1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Sbg1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/sbg1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v5Sbg1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Sbg1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/sbg1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v5Sbg1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Sbg1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/sbg1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v5Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v5Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v5Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v5Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v5Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v5Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v5/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v6Bhs1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Bhs1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/bhs1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v6Bhs1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Bhs1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/bhs1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v6Bhs1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Bhs1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/bhs1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v6Bhs1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Bhs1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/bhs1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v6Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v6Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v6Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v6Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v6Rbx2aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Rbx2aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v6Rbx2aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Rbx2aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v6Rbx2aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Rbx2aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v6Rbx2aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Rbx2aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v6Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v6Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v6Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v6Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v6Rbx2bEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Rbx2bEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2b/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v6Rbx2bEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Rbx2bEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2b/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v6Rbx2bEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Rbx2bEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2b/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v6Rbx2bEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Rbx2bEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2b/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v6Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v6Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v6Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v6Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v6Sbg1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Sbg1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/sbg1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v6Sbg1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Sbg1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/sbg1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v6Sbg1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Sbg1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/sbg1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v6Sbg1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Sbg1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/sbg1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v6Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v6Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v6Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v6Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v6Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v6Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v6/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v7Bhs1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Bhs1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/bhs1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v7Bhs1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Bhs1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/bhs1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v7Bhs1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Bhs1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/bhs1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v7Bhs1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Bhs1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/bhs1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v7Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v7Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v7Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v7Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v7Rbx2aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Rbx2aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v7Rbx2aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Rbx2aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v7Rbx2aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Rbx2aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v7Rbx2aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Rbx2aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v7Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v7Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v7Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v7Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v7Rbx2bEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Rbx2bEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2b/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v7Rbx2bEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Rbx2bEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2b/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v7Rbx2bEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Rbx2bEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2b/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v7Rbx2bEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Rbx2bEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2b/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v7Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v7Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v7Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v7Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v7Sbg1aEnterpriseFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Sbg1aEnterpriseFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/sbg1a/enterprise/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v7Sbg1aEnterpriseFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Sbg1aEnterpriseFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/sbg1a/enterprise/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v7Sbg1aEnterpriseHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Sbg1aEnterpriseHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/sbg1a/enterprise/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v7Sbg1aEnterpriseHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Sbg1aEnterpriseHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/sbg1a/enterprise/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2016v7Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2016v7Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2016v7Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2016v7Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2016v7Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2016v7Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2016v7/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v1Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v1Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v1Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v1Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v1Eri1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Eri1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/eri1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v1Eri1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Eri1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/eri1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v1Eri1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Eri1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/eri1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v1Eri1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Eri1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/eri1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v1Lim1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Lim1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/lim1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v1Lim1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Lim1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/lim1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v1Lim1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Lim1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/lim1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v1Lim1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Lim1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/lim1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v1Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v1Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v1Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v1Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v1Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v1Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v1Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v1Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v1Rbx2dInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Rbx2dInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/rbx2d/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v1Rbx2dInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Rbx2dInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/rbx2d/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v1Rbx2dInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Rbx2dInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/rbx2d/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v1Rbx2dInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Rbx2dInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/rbx2d/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v1Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v1Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v1Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v1Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v1Waw1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Waw1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/waw1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v1Waw1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v1Waw1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/waw1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v1Waw1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Waw1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/waw1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v1Waw1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v1Waw1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v1/waw1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v2Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v2Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v2Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v2Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v2Eri1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Eri1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/eri1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v2Eri1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Eri1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/eri1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v2Eri1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Eri1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/eri1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v2Eri1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Eri1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/eri1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v2Lim1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Lim1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/lim1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v2Lim1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Lim1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/lim1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v2Lim1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Lim1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/lim1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v2Lim1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Lim1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/lim1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v2Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v2Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v2Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v2Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v2Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v2Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v2Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v2Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v2Rbx2dInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Rbx2dInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/rbx2d/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v2Rbx2dInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Rbx2dInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/rbx2d/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v2Rbx2dInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Rbx2dInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/rbx2d/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v2Rbx2dInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Rbx2dInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/rbx2d/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v2Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v2Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v2Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v2Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v2Waw1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Waw1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/waw1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v2Waw1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v2Waw1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/waw1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v2Waw1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Waw1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/waw1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v2Waw1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v2Waw1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v2/waw1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v3Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v3Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v3Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v3Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v3Eri1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Eri1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/eri1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v3Eri1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Eri1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/eri1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v3Eri1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Eri1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/eri1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v3Eri1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Eri1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/eri1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v3Lim1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Lim1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/lim1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v3Lim1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Lim1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/lim1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v3Lim1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Lim1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/lim1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v3Lim1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Lim1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/lim1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v3Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v3Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v3Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v3Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v3Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v3Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v3Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v3Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v3Rbx2dInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Rbx2dInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/rbx2d/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v3Rbx2dInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Rbx2dInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/rbx2d/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v3Rbx2dInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Rbx2dInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/rbx2d/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v3Rbx2dInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Rbx2dInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/rbx2d/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v3Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v3Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v3Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v3Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v3Waw1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Waw1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/waw1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v3Waw1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v3Waw1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/waw1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v3Waw1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Waw1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/waw1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v3Waw1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v3Waw1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v3/waw1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v4Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v4Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v4Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v4Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v4Eri1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Eri1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/eri1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v4Eri1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Eri1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/eri1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v4Eri1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Eri1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/eri1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v4Eri1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Eri1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/eri1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v4Lim1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Lim1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/lim1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v4Lim1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Lim1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/lim1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v4Lim1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Lim1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/lim1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v4Lim1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Lim1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/lim1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v4Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v4Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v4Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v4Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v4Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v4Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v4Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v4Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v4Rbx2dInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Rbx2dInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/rbx2d/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v4Rbx2dInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Rbx2dInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/rbx2d/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v4Rbx2dInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Rbx2dInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/rbx2d/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v4Rbx2dInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Rbx2dInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/rbx2d/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v4Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v4Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v4Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v4Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v4Waw1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Waw1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/waw1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v4Waw1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v4Waw1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/waw1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v4Waw1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Waw1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/waw1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v4Waw1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v4Waw1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v4/waw1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v5Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v5Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v5Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v5Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v5Eri1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Eri1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/eri1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v5Eri1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Eri1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/eri1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v5Eri1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Eri1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/eri1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v5Eri1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Eri1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/eri1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v5Lim1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Lim1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/lim1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v5Lim1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Lim1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/lim1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v5Lim1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Lim1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/lim1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v5Lim1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Lim1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/lim1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v5Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v5Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v5Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v5Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v5Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v5Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v5Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v5Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v5Rbx2dInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Rbx2dInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/rbx2d/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v5Rbx2dInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Rbx2dInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/rbx2d/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v5Rbx2dInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Rbx2dInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/rbx2d/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v5Rbx2dInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Rbx2dInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/rbx2d/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v5Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v5Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v5Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v5Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v5Waw1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Waw1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/waw1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v5Waw1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v5Waw1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/waw1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v5Waw1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Waw1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/waw1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v5Waw1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v5Waw1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v5/waw1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v6Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v6Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v6Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v6Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v6Eri1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Eri1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/eri1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v6Eri1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Eri1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/eri1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v6Eri1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Eri1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/eri1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v6Eri1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Eri1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/eri1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v6Lim1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Lim1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/lim1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v6Lim1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Lim1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/lim1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v6Lim1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Lim1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/lim1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v6Lim1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Lim1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/lim1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v6Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v6Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v6Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v6Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v6Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v6Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v6Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v6Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v6Rbx2dInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Rbx2dInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/rbx2d/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v6Rbx2dInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Rbx2dInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/rbx2d/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v6Rbx2dInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Rbx2dInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/rbx2d/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v6Rbx2dInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Rbx2dInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/rbx2d/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v6Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v6Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v6Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v6Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v6Waw1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Waw1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/waw1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v6Waw1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v6Waw1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/waw1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v6Waw1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Waw1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/waw1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v6Waw1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v6Waw1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v6/waw1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v7Bhs1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Bhs1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/bhs1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v7Bhs1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Bhs1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/bhs1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v7Bhs1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Bhs1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/bhs1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v7Bhs1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Bhs1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/bhs1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v7Eri1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Eri1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/eri1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v7Eri1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Eri1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/eri1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v7Eri1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Eri1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/eri1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v7Eri1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Eri1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/eri1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v7Lim1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Lim1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/lim1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v7Lim1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Lim1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/lim1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v7Lim1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Lim1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/lim1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v7Lim1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Lim1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/lim1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v7Rbx2aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Rbx2aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/rbx2a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v7Rbx2aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Rbx2aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/rbx2a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v7Rbx2aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Rbx2aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/rbx2a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v7Rbx2aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Rbx2aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/rbx2a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v7Rbx2bInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Rbx2bInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/rbx2b/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v7Rbx2bInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Rbx2bInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/rbx2b/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v7Rbx2bInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Rbx2bInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/rbx2b/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v7Rbx2bInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Rbx2bInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/rbx2b/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v7Rbx2dInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Rbx2dInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/rbx2d/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v7Rbx2dInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Rbx2dInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/rbx2d/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v7Rbx2dInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Rbx2dInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/rbx2d/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v7Rbx2dInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Rbx2dInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/rbx2d/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v7Sbg1aInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Sbg1aInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/sbg1a/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v7Sbg1aInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Sbg1aInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/sbg1a/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v7Sbg1aInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Sbg1aInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/sbg1a/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v7Sbg1aInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Sbg1aInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/sbg1a/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly filer ressources */
  getDedicatedCloud2018v7Waw1cInfrastructureFilerHourlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Waw1cInfrastructureFilerHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/waw1c/infrastructure/filer/hourly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly filer ressources */
  getDedicatedCloud2018v7Waw1cInfrastructureFilerMonthlyByFilerProfile = (
    filerProfile: PriceDedicatedCloud2018v7Waw1cInfrastructureFilerMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/waw1c/infrastructure/filer/monthly/${filerProfile}`
    );
  };

  /** Get price of dedicated Cloud hourly host ressources */
  getDedicatedCloud2018v7Waw1cInfrastructureHostHourlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Waw1cInfrastructureHostHourlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/waw1c/infrastructure/host/hourly/${hostProfile}`
    );
  };

  /** Get price of dedicated Cloud monthly host ressources */
  getDedicatedCloud2018v7Waw1cInfrastructureHostMonthlyByHostProfile = (
    hostProfile: PriceDedicatedCloud2018v7Waw1cInfrastructureHostMonthlyEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request(
      'GET',
      `/price/dedicatedCloud/2018v7/waw1c/infrastructure/host/monthly/${hostProfile}`
    );
  };

  /** Get price of zone options */
  getDomainZoneOptionByOptionName = (
    optionName: PriceDomainZoneOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/domain/zone/option/${optionName}`);
  };

  /** Get the price for a private database */
  getHostingPrivateDatabaseByPrivateDatabaseName = (
    privateDatabaseName: PriceHostingPrivateDatabaseEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/hosting/privateDatabase/${privateDatabaseName}`);
  };

  /** Get the price for cdn option */
  getHostingWebCdnByCdnName = (cdnName: PriceHostingWebCdnEnum): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/hosting/web/cdn/${cdnName}`);
  };

  /** Get the price for extra sql perso option */
  getHostingWebExtraSqlPersoByExtraSqlPersoName = (
    extraSqlPersoName: PriceHostingWebExtraSqlPersoEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/hosting/web/extraSqlPerso/${extraSqlPersoName}`);
  };

  /** Get the price for hosted ssl option */
  getHostingWebSslBySslName = (sslName: PriceHostingWebSslEnum): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/hosting/web/ssl/${sslName}`);
  };

  /** Get the monthly price for an office license */
  getLicenseOfficeByOfficeName = (officeName: PriceLicenseOfficeEnum): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/license/office/${officeName}`);
  };

  /** Get the price of overTheBox offers */
  getOverTheBoxOfferByOfferName = (offerName: PriceOverTheBoxOfferEnum): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/overTheBox/offer/${offerName}`);
  };

  /** Get the monthly price for an Office 365 license */
  getSaasCsp2LicenseByLicenseName = (
    licenseName: PriceSaasCsp2LicenseEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/saas/csp2/license/${licenseName}`);
  };

  /** Get price of VPS Cloud 2013 */
  getVps2013v1ClassicModelByModelName = (
    modelName: PriceVps2013v1ClassicModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2013v1/classic/model/${modelName}`);
  };

  /** Get price of VPS Classic 2013 */
  getVps2013v1CloudModelByModelName = (
    modelName: PriceVps2013v1CloudModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2013v1/cloud/model/${modelName}`);
  };

  /** Get price of VPS Cloud Options 2013 */
  getVps2013v1CloudOptionByOptionName = (
    optionName: PriceVps2013v1CloudOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2013v1/cloud/option/${optionName}`);
  };

  /** Get price of VPS Low Latency 2013 */
  getVps2013v1LowlatModelByModelName = (
    modelName: PriceVps2013v1LowlatModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2013v1/lowlat/model/${modelName}`);
  };

  /** Get price of VPS Classic 2014 */
  getVps2014v1ClassicModelByModelName = (
    modelName: PriceVps2014v1ClassicModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2014v1/classic/model/${modelName}`);
  };

  /** Get price of VPS Cloud 2014 */
  getVps2014v1CloudModelByModelName = (
    modelName: PriceVps2014v1CloudModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2014v1/cloud/model/${modelName}`);
  };

  /** Get price of VPS Cloud Options 2014 */
  getVps2014v1CloudOptionByOptionName = (
    optionName: PriceVps2014v1CloudOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2014v1/cloud/option/${optionName}`);
  };

  /** Get price of VPS Cloud 2015 */
  getVps2015v1CloudModelByModelName = (
    modelName: PriceVps2015v1CloudModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2015v1/cloud/model/${modelName}`);
  };

  /** Get price of VPS Cloud Options 2015/2016 */
  getVps2015v1CloudOptionByOptionName = (
    optionName: PriceVps2015v1CloudOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2015v1/cloud/option/${optionName}`);
  };

  /** Get price of VPS Cloud RAM 2016 */
  getVps2015v1CloudramModelByModelName = (
    modelName: PriceVps2015v1CloudramModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2015v1/cloudram/model/${modelName}`);
  };

  /** Get price of VPS Cloud RAM Options 2015/2016 */
  getVps2015v1CloudramOptionByOptionName = (
    optionName: PriceVps2015v1CloudramOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2015v1/cloudram/option/${optionName}`);
  };

  /** Get price of VPS SSD 2015 */
  getVps2015v1SsdModelByModelName = (
    modelName: PriceVps2015v1SsdModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2015v1/ssd/model/${modelName}`);
  };

  /** Get price of VPS SSD Options 2015/2016 */
  getVps2015v1SsdOptionByOptionName = (
    optionName: PriceVps2015v1SsdOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2015v1/ssd/option/${optionName}`);
  };

  /** Get price of VPS SSD Discovery 2017 */
  getVps2017v1SsdModelByModelName = (
    modelName: PriceVps2017v1SsdModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2017v1/ssd/model/${modelName}`);
  };

  /** Get price of VPS SSD Discovery Options 2017 */
  getVps2017v1SsdOptionByOptionName = (
    optionName: PriceVps2017v1SsdOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2017v1/ssd/option/${optionName}`);
  };

  /** Get price of VPS Cloud 2017 */
  getVps2017v2CloudModelByModelName = (
    modelName: PriceVps2017v2CloudModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2017v2/cloud/model/${modelName}`);
  };

  /** Get price of VPS Cloud Options 2015/2016 */
  getVps2017v2CloudOptionByOptionName = (
    optionName: PriceVps2017v2CloudOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2017v2/cloud/option/${optionName}`);
  };

  /** Get price of VPS Cloud RAM 2017 */
  getVps2017v2CloudramModelByModelName = (
    modelName: PriceVps2017v2CloudramModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2017v2/cloudram/model/${modelName}`);
  };

  /** Get price of VPS Cloud RAM Options 2015/2016 */
  getVps2017v2CloudramOptionByOptionName = (
    optionName: PriceVps2017v2CloudramOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2017v2/cloudram/option/${optionName}`);
  };

  /** Get price of VPS SSD 2017 */
  getVps2017v2SsdModelByModelName = (
    modelName: PriceVps2017v2SsdModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2017v2/ssd/model/${modelName}`);
  };

  /** Get price of VPS SSD Options 2015/2016 */
  getVps2017v2SsdOptionByOptionName = (
    optionName: PriceVps2017v2SsdOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2017v2/ssd/option/${optionName}`);
  };

  /** Get price of VPS Cloud 2017 */
  getVps2017v3CloudModelByModelName = (
    modelName: PriceVps2017v3CloudModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2017v3/cloud/model/${modelName}`);
  };

  /** Get price of VPS Cloud Options 2015/2016 */
  getVps2017v3CloudOptionByOptionName = (
    optionName: PriceVps2017v3CloudOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2017v3/cloud/option/${optionName}`);
  };

  /** Get price of VPS Cloud RAM 2017 */
  getVps2017v3CloudramModelByModelName = (
    modelName: PriceVps2017v3CloudramModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2017v3/cloudram/model/${modelName}`);
  };

  /** Get price of VPS Cloud RAM Options 2015/2016 */
  getVps2017v3CloudramOptionByOptionName = (
    optionName: PriceVps2017v3CloudramOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2017v3/cloudram/option/${optionName}`);
  };

  /** Get price of VPS SSD 2017 */
  getVps2017v3SsdModelByModelName = (
    modelName: PriceVps2017v3SsdModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2017v3/ssd/model/${modelName}`);
  };

  /** Get price of VPS SSD Options 2015/2016 */
  getVps2017v3SsdOptionByOptionName = (
    optionName: PriceVps2017v3SsdOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2017v3/ssd/option/${optionName}`);
  };

  /** Get price of VPS Cloud 2017 */
  getVps2018v1CloudModelByModelName = (
    modelName: PriceVps2018v1CloudModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2018v1/cloud/model/${modelName}`);
  };

  /** Get price of VPS Cloud Options 2015/2016 */
  getVps2018v1CloudOptionByOptionName = (
    optionName: PriceVps2018v1CloudOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2018v1/cloud/option/${optionName}`);
  };

  /** Get price of VPS Cloud RAM 2017 */
  getVps2018v1CloudramModelByModelName = (
    modelName: PriceVps2018v1CloudramModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2018v1/cloudram/model/${modelName}`);
  };

  /** Get price of VPS Cloud RAM Options 2015/2016 */
  getVps2018v1CloudramOptionByOptionName = (
    optionName: PriceVps2018v1CloudramOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2018v1/cloudram/option/${optionName}`);
  };

  /** Get price of VPS SSD 2018 */
  getVps2018v1SsdModelByModelName = (
    modelName: PriceVps2018v1SsdModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2018v1/ssd/model/${modelName}`);
  };

  /** Get price of VPS SSD Options 2015/2016 */
  getVps2018v1SsdOptionByOptionName = (
    optionName: PriceVps2018v1SsdOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2018v1/ssd/option/${optionName}`);
  };

  /** Get price of VPS SSD APAC */
  getVps2018v2SsdModelByModelName = (
    modelName: PriceVps2018v2SsdModelEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2018v2/ssd/model/${modelName}`);
  };

  /** Get price of VPS SSD APAC Options */
  getVps2018v2SsdOptionByOptionName = (
    optionName: PriceVps2018v2SsdOptionEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/2018v2/ssd/option/${optionName}`);
  };

  /** Get price of VPS Classic */
  getVpsClassicModelByModelName = (modelName: PriceVpsClassicModelEnum): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/classic/model/${modelName}`);
  };

  /** Get price of VPS Cloud */
  getVpsCloudModelByModelName = (modelName: PriceVpsCloudModelEnum): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/cloud/model/${modelName}`);
  };

  /** Get price of VPS Cloud Options */
  getVpsCloudOptionByOptionName = (optionName: PriceVpsCloudOptionEnum): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/cloud/option/${optionName}`);
  };

  /** Get price of VPS Low Latency */
  getVpsLowlatModelByModelName = (modelName: PriceVpsLowlatModelEnum): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/vps/lowlat/model/${modelName}`);
  };

  /** Get the price of address move option fee */
  getXdslAddressMoveFeeByOption = (option: PriceXdslAddressMoveFeeEnum): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/xdsl/addressMove/fee/${option}`);
  };

  /** Get the price of options installation fee */
  getXdslInstallationByOffer = (offer: PriceXdslInstallationEnum): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/xdsl/installation/${offer}`);
  };

  /** Get the price of xdsl offers */
  getXdslOffersByOffersName = (offersName: PriceXdslOffersEnum): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/xdsl/offers/${offersName}`);
  };

  /** Get the price of options installation fee */
  getXdslOptionsInstallationByOption = (
    option: PriceXdslOptionsInstallationEnum
  ): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/xdsl/options/installation/${option}`);
  };

  /** Get the price of IPv4 options */
  getXdslOptionsIpv4ByIpRange = (ipRange: PriceXdslOptionsIpv4Enum): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/xdsl/options/ipv4/${ipRange}`);
  };

  /** Get the price of line action */
  getXdslOptionsLineByLineAction = (lineAction: PriceXdslOptionsLineEnum): Promise<OrderPrice> => {
    return this.ovh.request('GET', `/price/xdsl/options/line/${lineAction}`);
  };
}

export { PriceHandler };
